<template>
  <div class="pa-4">
    <!-- دکمه باز کردن پاپ‌آپ ساخت دسته‌ای -->
    <v-btn
      class="btn-get-code rounded-lg px-5"
      elevation="2"
      @click="showBatchModal = true"
    >
      <v-icon left>mdi-file-excel-box</v-icon>
      ساخت خودکار کیوآر متن از اکسل
    </v-btn>

    <batch-text-qr-modal
      v-if="showBatchModal"
      v-model="showBatchModal"
      :domain-id-prop="5"
      @saved="fetchQrList"
      @close="showBatchModal = false"
    />
  </div>
</template>

<script>
import BatchTextQrModal from "./BatchTextQrModal.vue";

export default {
  name: "IndexBatchQr",
  components: {
    BatchTextQrModal,
  },
  data() {
    return {
      showBatchModal: false,
    };
  },
  methods: {
    fetchQrList() {
      if (this.$fetch) {
        this.$fetch();
      }
    },
  },
};
</script>
